import { Link } from 'react-router-dom';
import { heroData } from '@/mocks/homeData';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Soft%20abstract%20flowing%20organic%20shapes%20in%20warm%20peach%20coral%20and%20cream%20tones%2C%20gentle%20gradients%2C%20minimalist%20elegant%20design%2C%20feminine%20wellness%20concept%2C%20soft%20diffused%20lighting%2C%20dreamy%20ethereal%20atmosphere%2C%20smooth%20curves%2C%20medical%20aesthetic%20with%20artistic%20touch&width=1600&height=900&seq=hero-bg-main&orientation=landscape"
          alt="爱液视频 - 女性生理健康科普"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/15 to-black/40"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6 py-20 md:py-28 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-background-50/15 backdrop-blur-sm border border-background-50/20 mb-6">
          <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></span>
          <span className="text-sm text-background-50/90">2026年全新升级 · 500+科普视频</span>
        </div>

        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 mb-4 md:mb-6 leading-tight">
          {heroData.title}
        </h1>

        <p className="text-base md:text-lg text-background-50/80 max-w-2xl mx-auto mb-6 md:mb-8 leading-relaxed">
          {heroData.subtitle}
        </p>

        <p className="text-sm md:text-base text-background-50/60 max-w-xl mx-auto mb-8 md:mb-10">
          {heroData.description}
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4 mb-10 md:mb-14">
          <Link
            to="/category/jiankang-panduan"
            className="w-full sm:w-auto px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-medium text-sm md:text-base hover:bg-primary-600 transition-all duration-200 cursor-pointer whitespace-nowrap shadow-lg shadow-primary-500/25"
          >
            <i className="ri-play-circle-line mr-2"></i>
            开始观看
          </Link>
          <Link
            to="/about"
            className="w-full sm:w-auto px-8 py-3.5 rounded-full border border-background-50/40 text-background-50 font-medium text-sm md:text-base hover:bg-background-50/10 transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-information-line mr-2"></i>
            了解更多
          </Link>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 max-w-3xl mx-auto">
          {heroData.stats.map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="font-heading text-2xl md:text-3xl font-bold text-background-50">
                {stat.value}
              </div>
              <div className="text-xs md:text-sm text-background-50/60 mt-1">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}